class ProductVideoHandler {
  constructor() {
    this.videos = document.querySelectorAll(".product-video");
    this.observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };
    this.videoStates = new Map(); // Track video states

    this.init();
  }

  init() {
    // Set up intersection observer
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.observerOptions);

    this.videos.forEach((video) => {
      // Initialize video state
      this.videoStates.set(video, {
        hasPlayedOnce: false,
        isEnded: false,
      });

      // Observe each video
      this.observer.observe(video);

      // Add hover listeners
      video.addEventListener("mouseenter", () => this.handleHover(video));

      // Track when video ends
      video.addEventListener("ended", () => {
        const state = this.videoStates.get(video);
        if (state) {
          state.isEnded = true;
        }
      });

      // Ensure video is muted (required for autoplay)
      video.muted = true;
    });
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      const video = entry.target;
      const state = this.videoStates.get(video);

      if (entry.isIntersecting && state && !state.hasPlayedOnce) {
        // First time in viewport - play the video
        this.playVideo(video);
        state.hasPlayedOnce = true;
      }
    });
  }

  handleHover(video) {
    const state = this.videoStates.get(video);

    // Only restart if video has ended
    if (state && state.isEnded) {
      video.currentTime = 0; // Reset to beginning
      this.playVideo(video);
      state.isEnded = false;
    }
  }

  playVideo(video) {
    // Only play if the video is at least 50% loaded
    if (video.readyState >= 3) {
      video.play().catch(() => {
        // Handle any autoplay restrictions
        console.log("Autoplay prevented");
      });
    } else {
      // If video isn't loaded enough, wait for it
      video.addEventListener(
        "canplay",
        () => {
          video.play().catch(() => {
            console.log("Autoplay prevented");
          });
        },
        { once: true },
      );
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => new ProductVideoHandler());
} else {
  new ProductVideoHandler();
}
